import * as rq from '@tanstack/react-query';
import { z } from 'zod';

import { UserSchema } from '../entities/user';
import { createUser } from '../queries/__mocked_data__/users-state';

export namespace CreateUserMutation {
  export type Input = {
    firstName: string;
    lastName: string;
    email: string;
    roleId: string;
  };
  export const OutputSchema = z.object({
    user: UserSchema.pick({ id: true }),
  });
  export type Output = z.infer<typeof OutputSchema>;

  function useMutationFn() {
    return async function mutationFn(input: Input): Promise<Output> {
      // Add artificial 500ms delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      const result = createUser({
        firstName: input.firstName,
        lastName: input.lastName,
        email: input.email,
        roleId: input.roleId,
      });

      if (!result) {
        throw new Error('Failed to create user - invalid role ID');
      }

      return result;
    };
  }

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const mutationFn = useMutationFn();

    return rq.useMutation<Output, unknown, Input>({
      mutationFn,
      // TODO: use first argument if id is inside Output
      async onSuccess() {
        await queryClient.invalidateQueries({
          queryKey: ['user-management', 'users'],
        });
      },
    });
  }
}
